import { Props } from "@greeter/matter";
import { classNames } from "@greeter/util";

import css from "./WarningHint.module.scss";

export type WarningHintProps = Props;

export function WarningHint({ className, ...props }: Props) {
  return <span {...classNames(className, css.WarningHint)} {...props} />;
}
